<template>
    <div class="c-var p-achievement-detail" v-loading="loading">
        <div class="m-main-box">
            <div class="m-achievement-info">
                <div class="m-sub-list">
                    <div
                        v-for="item in source?.SeriesAchievementList || []"
                        :key="item.ID"
                        class="u-sub-achievement"
                        @click="() => changeCurrent(item)"
                    >
                        <img :src="iconUrl(item.IconID)" />
                    </div>
                </div>
                <wiki-item :item="source" />
                <button  class="m-confirm" :class="{complete: isComplete,disabled:!isVirtual}" @click="setConfirm">{{ isComplete ? "已完成" : "设为已完成" }}</button>
            </div>
            <div class="m-wiki">
                <div class="m-wiki-header">
                    <div class="u-title">成就攻略</div>
                    <div class="u-avatar-list">
                        <div v-for="item in authors" :key="item.user_id" class="u-avatar">
                            <img :src="showAvatar(item.user_avatar)" />
                        </div>
                    </div>
                    <div class="u-time">
                        {{ updated_at }}
                    </div>
                </div>
                <div class="m-content-box">
                    <Article id="wikiArticle" :content="clearContent(wiki_post?.post?.content)" />
                </div>

                <div class="u-show-log">查看历史修订</div>
            </div>
        </div>
        <div class="m-comments">
            <miniprogram-comment-list :source-id="id" type="achievement" />
        </div>
        <suspend-common
            v-if="!isFromTarget"
            class="u-suspend-common"
            :btn-options="btnOptions"
            :drawer-options="drawerOptions"
            style="width: 100%"
            @search="onSearch"
            ref="suspendCommon"
        >
            <template #default>
                <div class="m-more-action">
                    <div class="u-action" @click="() => (userSelectShow = true)">
                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M17.5 12a2.25 2.25 0 012.25 2.25V15c0 2.956-2.79 6-7.5 6s-7.5-3.044-7.5-6v-.75A2.25 2.25 0 017 12h10.5zm-5.25-9.75a4.125 4.125 0 110 8.25 4.125 4.125 0 010-8.25z" fill="#FEDAA3"/></svg>
                    </div>
                    <div class="u-action" @click="()=>$refs.suspendCommon.clickDrawer({ type: 'collect', text: '收藏' }, 1)">
                        <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24" v-if="$refs.suspendCommon?.isCollect" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M467.584 153.568c11.136-13.312 26.208-25.952 44.544-25.632 21.76-.064 38.016 16.992 50.272 33.056 23.968 32.576 42.336 68.768 62.368 103.808 10.112 17.472 18.944 35.776 30.944 52.096 8.48 11.616 22.08 17.824 35.712 21.056 41.6 10.4 83.744 18.528 125.152 29.792 21.6 6.304 44.192 12.64 61.952 27.136 15.04 12.096 20.992 33.408 15.552 51.776-6.752 23.456-22.208 42.976-36.832 62.048-23.584 29.536-48.576 57.92-72.992 86.784C662.688 473.28 540.384 351.904 418.88 229.664c15.072-26.048 29.408-52.8 48.704-76.096zm-261.696 10.688c2.624.128 7.872.32 10.464.448l-.384 2.816c9.92.928 18.688 6.432 25.568 13.376 39.424 39.488 78.976 78.848 118.304 118.4 45.024 42.464 87.808 87.232 131.904 130.656C577.6 515.808 663.36 601.728 749.312 687.488c38.24 40.672 78.656 79.232 117.76 119.04 9.824 10.336 22.208 19.36 27.2 33.216 3.552 14.464 1.76 31.328-9.568 42.016-14.528 17.792-44.448 19.168-60.544 2.816-18.272-17.984-36.544-36.032-54.336-54.496-.384 20.736-4.704 44.672-22.784 57.536-17.76 12.8-41.184 8.64-60.704 2.72-38.56-12.352-74.752-30.816-111.648-47.296-17.632-7.616-34.624-17.312-53.44-21.792-14.848-3.392-29.472 2.72-42.848 8.544-38.368 17.12-76.128 35.648-115.072 51.456C344.32 888.544 324.672 896 304 896.032c-15.68.16-31.328-7.968-39.296-21.632-10.368-17.44-10.88-38.528-11.072-58.304 1.088-50.336 7.936-100.288 11.968-150.432 1.088-14.304 1.504-29.568-5.568-42.56-8.832-16.032-21.952-29.024-33.472-43.072-26.752-31.968-55.168-62.752-78.816-97.184-12.576-18.88-24.896-42.016-17.568-65.248 6.176-20.832 26.688-32.352 45.664-39.648 36.256-13.536 74.496-20.544 112.032-29.536-35.2-34.912-70.08-70.144-105.248-105.12-7.616-7.424-14.272-16.544-15.264-27.424l-2.848.608.384-13.696 2.656.896c2.624-18.88 19.616-34.656 38.496-36.608l-.16-2.816z" fill="#FEDAA3"/></svg>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10.288 4.836c.778-1.289 2.646-1.289 3.424 0l1.15 1.903a2 2 0 001.257.914l2.166.505c1.465.341 2.043 2.119 1.058 3.256l-1.455 1.681a2 2 0 00-.48 1.48l.188 2.215c.128 1.5-1.384 2.598-2.77 2.012l-2.049-.864a2 2 0 00-1.554 0l-2.049.864c-1.387.585-2.898-.513-2.77-2.012l.189-2.216a2 2 0 00-.48-1.479l-1.456-1.68c-.985-1.138-.407-2.916 1.058-3.257l2.166-.505a2 2 0 001.258-.914l1.149-1.903z" fill="#FEDAA3" stroke="#FEDAA3" stroke-width="1.5"/></svg>
                    </div>
                    <div class="u-action" @click="()=> $refs.suspendCommon.clickDrawer({ type: 'pin', text: '固定按钮' }, 1)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="$refs.suspendCommon?.fixIsActive" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15 4.5l-4 4L7 10l-1.5 1.5 7 7L14 17l1.5-4 4-4M9 15l-4.5 4.5M14.5 4L20 9.5" stroke="#FEDAA3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="100" height="100" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M624.864 119.424c6.144-7.872 13.696-16.928 24.672-16.64 7.68-.736 14.24 3.808 19.2 9.184 81.984 82.304 164.32 164.192 246.08 246.688 7.776 5.92 7.456 16.416 6.016 25.088-2.304 7.488-9.152 11.968-14.848 16.736-58.272 49.504-116.512 99.072-174.784 148.544-4.48 4.416-10.912 5.44-16.768 6.912-5.696 40.8-13.376 81.28-18.08 122.208 6.528 16.32 5.28 34.368 8.16 51.488 1.984 8.864-1.728 17.792-7.84 24.128-24.608 23.552-47.776 48.544-72.544 71.936-8.96 9.056-24.864 6.912-32.96-2.272-51.136-51.008-101.92-102.368-153.056-153.312-71.616 70.784-142.272 142.624-213.632 213.664-11.424 11.008-21.44 24.384-35.968 31.424-14.144 4.8-31.008 4.512-43.84-3.776-10.336-7.616-19.36-18.144-21.76-31.072-3.808-16.288 2.208-33.984 14.592-45.056 77.344-78.144 155.424-155.616 232.768-233.728-56.736-56.032-112.64-113.024-169.216-169.248-8.128-9.088-7.648-26.016 2.368-33.632 24.416-24.672 48.992-49.12 73.44-73.696 3.808-3.424 9.056-4.16 13.984-4.096 18.112.192 36.064 2.944 53.984 5.408 41.824-4.8 83.744-8.992 125.408-15.264.608-6.048 2.624-11.904 6.528-16.64 49.44-58.24 98.848-116.544 148.096-174.976z" fill="#D9D9D9"/></svg>
                    </div>
                </div>
            </template>
        </suspend-common>

        <user-select-drawer :visible.sync="userSelectShow" :current-role="currentRole" @change="setRole" />

        <confirm-ok-drawer :visible.sync="conformShow" @confirm="confirmOk" />
    </div>
</template>

<script lang="js">
import SuspendCommon from  '@jx3box/jx3box-common-ui/src/SuspendCommon.vue';
import { publishLink, showAvatar, showSchoolIcon, ts2str } from "@jx3box/jx3box-common/js/utils";
import { postHistory, postStat } from "@jx3box/jx3box-common/js/stat";
import {
    cancelVirtualRoleAchievements,
    get_achievement, getRoleGameAchievements, getVirtualRoleAchievements, setVirtualRoleAchievements } from "@/service/achievement";
import { wiki } from "@jx3box/jx3box-common/js/wiki_v2";
import { reportNow } from "@jx3box/jx3box-common/js/reporter";
import User from "@jx3box/jx3box-common/js/user";
import { getConfig } from "@jx3box/jx3box-common/js/api_misc";
import { report } from "@/service/user";
import { icon_url } from "@/filters";
import iconUrl from "@/filters/icon-url";
import Article from "@jx3box/jx3box-editor/src/Article.vue";
import UserSelectDrawer from "@/components/cj/mobile/user-select-drawer.vue";
import MiniprogramCommentList from "@/components/cj/mobile/comment-list.vue";
import WikiItem from "@/components/cj/mobile/wiki-item.vue";
import ConfirmOkDrawer from "@/components/cj/mobile/confirm-ok-drawer.vue";

export default {
    name: "CjMobileDetail",
    components: { ConfirmOkDrawer, WikiItem, MiniprogramCommentList, UserSelectDrawer,SuspendCommon,Article },
    data() {
        return {
            source: {},
            wiki_post: "",
            compatible: false,
            is_empty: true,

            imageCount: 0,
            loadedImageCount: 0,
            images: [],
            imagesLoaded: false,

            userSelectShow:false,
            currentRole: this.$store.state.role,
            loading: false,
            conformShow: false
        };
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit("update:visible", val);
            }
        },
        id() {
            return this.$route.params.source_id;
        },
        post_id: function () {
            return this.$route.params.post_id;
        },
        isRevision: function () {
            return !!this.$route.params.post_id;
        },
        author_id: function () {
            return ~~this.wiki_post.post?.user_id;
        },
        client: function () {
            return this.$store.state.client;
        },
        user_name: function () {
            return this.wiki_post?.post?.user_nickname;
        },
        updated_at: function () {
            return ts2str(this.wiki_post?.post?.updated);
        },
        authors: function () {
            if (!this.isRevision) {
                return (
                    this.wiki_post?.users
                        ?.filter((user) => user.id)
                        ?.map((user) => {
                            return {
                                user_id: user.id,
                                user_avatar: user.avatar,
                                display_name: user.nickname,
                            };
                        }) || []
                );
            }
            return [];
        },
        favTitle: function () {
            return this.wiki_post?.source?.Name;
        },
        prefix() {
            return this.client === "std" ? "www" : "origin";
        },
        isFromTarget(){
            return false;
        },
        drawerOptions(){
            return {
                hideType: ['report'], //需要隐藏的type,如['search','pin']
                direction: 'btt', //弹出框方向，btt、ttb、rtl、ltr
                drawerTitle: this.source.Name,//弹出框标题
                author: {
                    name: this.author_info?.display_name, //作者名称
                    avatar: this.author_info?.user_avatar, //作者头像
                    author_id:this.author_id, //作者id
                },
                subscribeType: 'wiki', //订阅类型，用于区分调用百科、文章、作者、帖子等订阅接口，
                postType: 'achievement',//订阅、收藏接口的type,如'face','bps','article'等
                id: this.post_id, //页面数据ID，用于收藏订阅操作
                title: this.source.Name || document.title || '', //默认固定标题,默认取页面标题
                url: window.location.href, //默认取浏览器地址
                laterOn: {
                    author_id: this.author_id || 0, //作者id
                    content_meta_id: this.post_id
                }
            }
        },
        btnOptions(){
            return {
                showHome: true, //是否显示home区域，和Icon区域二选一,home区域优先级高于icon区域
                showIcon: false, //是否显示icon区域,此处为false后，则下列配置无效

                showMore: true, //是否显示更多
            }
        },
        completeAchievements() {
            return this.$store.state.achievements || [];
        },
        achievementsVirtual() {
            return this.$store.state.achievementsVirtual || [];
        },
        isComplete(){
            return this.hadCompleted(this.id);
        },
        isVirtual(){
            return !this.currentRole?.jx3id;
        }
    },
    watch:{
        id: {
            handler() {
                this.loadData();
            },
        },
        post_id: {
            handler() {
                this.loadRevision();
            },
        },
        currentRole: {
            deep: true,
            handler(val) {
                if (!val) return;
                localStorage.setItem("wiki_last_sync", val.jx3id || 0);
                this.$store.commit("SET_STATE", { key: "role", value: val });
                const { jx3id } = val;
                if (jx3id) {
                    this.$store.commit("SET_STATE", { key: "achievementsVirtual", value: [] });
                    this.loadRoleAchievements(jx3id);
                } else {
                    if (jx3id === 0) {
                        // 虚拟角色
                        this.loadVirtualAchievements();
                    }
                    this.$store.commit("SET_STATE", { key: "achievements", value: [], isSession: true });
                }
            },
        },
    },
    methods: {
        iconUrl,
        showAvatar,
        icon_url,
        next(){

        },
        onSearch(){
            if(isMiniProgram()){
                wx.miniProgram.navigateTo({ url: `/pages/search/search-detail/search-detail?app=wiki&filter_category=成就` });
            }
        },
        setRole(val){
            this.currentRole = val;
            this.userSelectShow = false;
        },
        openChild(){
            this.childrenShow = true;
            console.log(111);
        },
        clearContent(content){
            return (content || "").replace(/ style="[^"]*"/g, "")
                .replace(/<i?frame.*?src="(.*?)".*?>/g, (match, src) => {
                    return `<a href="${src}" target="_blank">${src}</a>`;
                })
                .replace(/<i?frame.*?src="(.*?)".*?>.*?<\/i?frame>/g, (match, src) => {
                    return `<a href="${src}" target="_blank">${src}</a>`;
                })
        },
        publish_url: publishLink,
        triggerStat: function () {
            if (this.client == "origin") {
                postStat("origin_cj", this.id);
            } else {
                postStat("cj", this.id);
            }
        },
        changeCurrent(item){
            this.$router.push({
                name: "view",
                params: {
                    source_id: item.ID,
                }
            })
        },
        initImageLoader() {
            // 在DOM更新后获取所有图片
            this.$nextTick(() => {
                const container = document.getElementById("wikiArticle");
                if (!container) {
                    this.setGlobalReady();
                    return;
                }

                const images = container.querySelectorAll("img");
                this.images = images;
                this.imageCount = images.length;

                if (this.imageCount === 0) {
                    this.setGlobalReady();
                    return;
                }

                // 手动预加载所有图片
                this.preloadAllImages(images);
            });
        },

        // 手动预加载所有图片
        preloadAllImages(images) {
            let loadedInThisBatch = 0;
            let totalProcessed = 0;
            Array.from(images).forEach((img, index) => {
                // 记录原始src
                const originalSrc = img.src;

                // 如果图片未加载
                if (!img.complete) {
                    // 创建一个Image对象来预加载
                    const tempImg = new Image();

                    tempImg.onload = () => {
                        loadedInThisBatch++;

                        // 在临时图片加载完成后，设置原始图片的src
                        img.src = originalSrc;

                        // 检查是否所有图片都已处理
                        this.checkImageLoadCompletion(images, loadedInThisBatch);
                    };

                    tempImg.onerror = () => {
                        console.error(`图片加载失败: ${originalSrc}`);
                        totalProcessed++;

                        // 即使加载失败，也要设置原始图片的src
                        img.src = originalSrc;

                        // 标记原始图片为已加载（错误情况）
                        this.handleImageLoad();
                    };

                    // 开始预加载
                    tempImg.src = originalSrc;
                } else {
                    // 图片已经加载完成
                    this.handleImageLoad();
                    totalProcessed++;
                }
            });
        },

        // 检查图片加载状态
        checkImageLoadCompletion(images, loadedCount) {
            if (images.length === this.loadedImageCount) {
                this.setGlobalReady();
                return;
            }

            // 设置超时检查，防止意外情况
            setTimeout(() => {
                const allLoaded = Array.from(images).every((img) => img.complete);

                if (allLoaded) {
                    this.setGlobalReady();
                } else if (this.loadedImageCount === images.length) {
                    this.setGlobalReady();
                }
            }, 3000);
        },

        // 判断是否全部完成
        handleImageLoad() {
            this.loadedImageCount++;
            if (this.loadedImageCount === this.imageCount) {
                this.setGlobalReady();
            }
        },

        // 设置全局就绪状态
        setGlobalReady() {
            if (this.imagesLoaded) return; // 避免重复设置

            this.imagesLoaded = true;
            window.__READY__ = true;
            console.log("全局状态设置成功: __READY__ = ", window.__READY__);
        },
        loadData: async function () {
            // 获取最新攻略
            if (this.id) {
                this.loading = true;
                await get_achievement(this.id, { client: this.client }).then((res) => {
                    this.source = res?.data?.data?.achievement || "";
                });
                await wiki.mix({ type: "achievement", id: this.id, client: this.client }).then((res) => {
                    const { post, source, compatible, isEmpty, users } = res;
                    this.wiki_post = {
                        post: post,
                        source: source,
                        users,
                    };
                    this.is_empty = isEmpty;
                    this.compatible = compatible;

                    reportNow({
                        caller: "cj_detail",
                        data: {
                            href: `${this.prefix}:/cj/view/${this.id}`,
                        },
                    });

                    User.isLogin() &&
                    postHistory({
                        source_type: this.client == "origin" ? "origin_cj" : "cj",
                        source_id: ~~this.id,
                        link: location.href,
                        title: post.title,
                    });
                }).finally(()=>{
                    this.loading = false;
                });
            }

            // 请注意，为防止QQBOT无法抓取完全，请不要删除
            if (this.isRobot) {
                // 数据加载后启动奇遇流程中的图片检测
                this.initImageLoader();
            }

            this.triggerStat();
        },
        loadRevision: function () {
            // 获取指定攻略
            wiki.getById(this.post_id).then((res) => {
                this.wiki_post = {
                    ...this.wiki_post,
                    post: res.data.data?.post,
                };
            });
            this.triggerStat();
        },
        ts2str,
        loadConfig() {
            getConfig({ key: "test_user_ua" }).then((res) => {
                const isTest = ~~res.data.data.val;

                if (isTest) {
                    report();
                }
            });
        },

        loadRoleAchievements(jx3id) {
            getRoleGameAchievements(jx3id).then((res) => {
                const achievements = res.data?.data?.achievements || "";
                const jx3id = res.data?.data?.jx3id;
                this.isSync = !!jx3id; // 是否在游戏中同步
                const list = achievements.split(",");
                this.$store.commit("SET_STATE", { key: "achievements", value: list, isSession: true });
            });
        },
        showSchoolIcon,
        // 获取虚拟角色成就列表
        loadVirtualAchievements() {
            if (!this.currentRole || this.currentRole.jx3id) return;
            getVirtualRoleAchievements().then((res) => {
                const achievements = res.data?.data?.achievements || "";
                const list = achievements.split(",");
                this.$store.commit("SET_STATE", { key: "achievementsVirtual", value: list });
            });
        },
        confirmOk(){
            this.finishVirtual([this.id])
        },
        hadCompleted(id) {
            const list = this.isVirtual ? this.achievementsVirtual : this.completeAchievements;
            return list.includes(id + "");
        },
        setConfirm(){
            if (!this.isVirtual) {
                return;
            }

            if (this.isComplete) {
                // 取消完成
                this.cancelVirtual([this.id])

                return;
            }

            this.conformShow = true;
        },

        finishVirtual(curr) {
            const ids = curr?curr: this.selectedAchievements.map((item) => item.ID + "");
            const data = {
                achievements: ids.join(),
            };
            setVirtualRoleAchievements(data).then((res) => {
                this.$notify({
                    title: "操作成功",
                    message: "已将选中成就标记为已完成",
                    type: "success",
                });
                const list = Array.from(new Set(this.achievementsVirtual.concat(ids)));
                this.$store.commit("SET_STATE", { key: "achievementsVirtual", value: list });
                this.isAll = false;
                this.achievements = this.achievements.map((item) => {
                    return {
                        ...item,
                        checked: false,
                    };
                });
            });
        },
        cancelVirtual(curr) {
            const ids = curr?curr: this.selectedAchievements.map((item) => item.ID + "");
            const data = {
                achievements: ids.join(),
            };
            cancelVirtualRoleAchievements(data).then((res) => {
                this.$notify({
                    title: "操作成功",
                    message: "已将选中成就标记为待完成",
                    type: "success",
                });
                const list = this.achievementsVirtual.filter((item) => !ids.includes(item));
                this.$store.commit("SET_STATE", { key: "achievementsVirtual", value: list });
                this.isAll = false;
                this.achievements = this.achievements.map((item) => {
                    return {
                        ...item,
                        checked: false,
                    };
                });
            });
        },
    },
    mounted() {
        if (this.post_id) {
            this.loadRevision();
        } else {
            this.loadData();
        }

        this.loadConfig();
    },
}
</script>

<style lang="less">
@import "../../../assets/css/miniprogram/var.less";

.u-suspend-common {
    padding-bottom: 2rem;
    margin: 0;
    .m-base {
        width: 100%;
        .m-more-action {
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;

            .u-action {
                display: flex;
                height: 24px;
                justify-content: center;
                align-items: center;
                flex: 1 0 0;
                svg{
                    height: 24px;
                    width: 24px;
                }
                &.disabled {
                    img {
                        opacity: 0.5;
                    }

                }
            }
        }
    }
    .m-more {
        .u-icon {
            display: none;
        }
    }
}

.p-achievement-detail {
    min-height: calc(100vh - 120px);
    background: #f1f1f1;
    @media (prefers-color-scheme: dark) {
        background: #000;
    }

    padding-bottom: 100px;

    .m-main-box {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px 20px 0;
    }

    .m-achievement-info {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .m-sub-list {
            display: flex;
            flex-direction: row;
            gap: 8px;
            align-items: center;
            .u-sub-achievement {
                width: 32px;
                height: 32px;
                border-radius: 4px;
                overflow: hidden;
            }
        }

        .m-confirm {
            display: flex;
            height: 48px;
            padding: 12px 16px;
            justify-content: center;
            align-items: center;
            gap: 8px;

            border-radius: var(--12, 12px);
            background: var(--primary-brand-2, #fedaa3);
            border: none;

            color: var(--primary-brand-3, #24292e);
            /* 16 Bold */
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; /* 150% */

            &.complete{
                opacity: 0.3;
            }

            &.disabled{
                opacity: 0.3;
            }
        }
    }

    .m-wiki {
        display: flex;
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        width: 100%;
        border-radius: 12px;
        box-sizing: border-box;
        border: 1px solid rgba(40, 40, 40, 0.05);
        background: var(--primary-brand-4, #282828);
        .m-wiki-header {
            display: flex;
            flex-direction: column;
            gap: 4px;
            .u-title {
                color: var(--black-80, rgba(255, 255, 255, 0.8));

                /* 16 Bold */
                font-size: 16px;
                font-style: normal;
                font-weight: 700;
                line-height: 24px; /* 150% */
            }

            .u-avatar-list {
                display: flex;
                align-items: center;

                .u-avatar {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: -8px;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }

            .u-time {
                color: var(--black-40, rgba(255, 255, 255, 0.4));

                /* 12 Regular */
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 18px; /* 150% */
            }
        }

        .m-content-box {
            overflow: auto;
            box-sizing: border-box;
            #wikiArticle {
                color: rgba(255, 255, 255, 0.8) !important;

                /* 14 Regular */
                font-size: 14px !important;
                font-style: normal !important;
                font-weight: 400 !important;
                line-height: 20px; /* 142.857% */

                box-sizing: border-box;
                overflow-x: hidden;

                ul {
                    padding-left: 12px !important;
                }

                .e-summary,
                .e-jx3-resource {
                    @media (prefers-color-scheme: dark) {
                        color: var(--black-100);
                        background: var(--black-20);
                    }
                }
                ul:has(.e-jx3-resource) {
                    padding: 0 !important;
                }
                ul:has(.e-summary) {
                    padding: 0 !important;
                }
                img {
                    margin: 0 !important;
                }

                div {
                    color: var(--black-100);
                }
                h1 {
                    font-weight: 700 !important;
                    line-height: 30px !important;
                    font-size: 20px !important;
                    margin-bottom: 15px !important;
                    color: var(--black-100);
                }

                h2 {
                    font-weight: 700 !important;
                    line-height: 27px !important;
                    font-size: 18px !important;
                    margin-bottom: 14px !important;
                    color: var(--black-100);
                }

                h3 {
                    font-weight: 700 !important;
                    line-height: 24px !important;
                    font-size: 16px !important;
                    margin-bottom: 12px !important;
                    color: var(--black-100);
                }

                h4 {
                    font-weight: 700 !important;
                    line-height: 20px !important;
                    font-size: 14px !important;
                    margin-bottom: 11px !important;

                    @media (prefers-color-scheme: dark) {
                        color: var(--black-100);
                        background: var(--black-20);
                    }
                }

                blockquote {
                    @media (prefers-color-scheme: dark) {
                        background: var(--black-20);
                    }
                }

                h5,
                h6 {
                    font-weight: 700 !important;
                    line-height: 18px !important;
                    font-size: 12px !important;
                    margin-bottom: 9px !important;
                    color: var(--black-100) !important;
                    @media (prefers-color-scheme: dark) {
                        background: var(--black-20);
                    }
                }

                .e-jx3-resource {
                    overflow: hidden;
                }

                p {
                    font-weight: 400 !important;
                    line-height: 20px !important;
                    font-size: 14px !important;
                    margin-bottom: 11px !important;
                    color: var(--black-100);
                }

                .text {
                    display: inline-block !important;
                    font-weight: 400 !important;
                    line-height: 20px !important;
                    font-size: 14px !important;
                    margin-bottom: 11px !important;
                    color: var(--black-100);
                }

                hr {
                    margin-bottom: 11px !important;
                    margin-top: 8px !important;
                }
            }
        }

        .u-show-log {
            margin-top: 20px;
            text-align: center;
            width: 100%;
            color: var(--black-40, rgba(255, 255, 255, 0.4));

            /* 12 Regular */
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px; /* 150% */
        }
    }
}
</style>
